var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.75H7.5C6.75 19.75 6.2 19.72 5.73 19.65C2.41 19.29 1.75 17.3 1.75 14V10C1.75 6.7 2.41 4.71 5.76 4.34C6.2 4.28 6.75 4.25 7.5 4.25H16.5C17.25 4.25 17.8 4.28 18.27 4.35C21.6 4.72 22.25 6.7 22.25 10V14C22.25 17.3 21.59 19.29 18.24 19.66C17.8 19.72 17.25 19.75 16.5 19.75ZM7.5 5.75C6.82 5.75 6.34 5.78 5.95 5.83C3.92 6.06 3.25 6.69 3.25 10V14C3.25 17.31 3.92 17.94 5.92 18.17C6.34 18.23 6.82 18.25 7.5 18.25H16.5C17.18 18.25 17.66 18.22 18.05 18.17C20.08 17.95 20.75 17.31 20.75 14V10C20.75 6.69 20.08 6.06 18.08 5.83C17.66 5.77 17.18 5.75 16.5 5.75H7.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2.75H4.5C4.09 2.75 3.75 2.41 3.75 2C3.75 1.59 4.09 1.25 4.5 1.25H19.5C19.91 1.25 20.25 1.59 20.25 2C20.25 2.41 19.91 2.75 19.5 2.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.75H5C4.59 22.75 4.25 22.41 4.25 22C4.25 21.59 4.59 21.25 5 21.25H20C20.41 21.25 20.75 21.59 20.75 22C20.75 22.41 20.41 22.75 20 22.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderVertical);
export default __webpack_public_path__ + "static/media/slider-vertical.41fe574804ac3d4e33926bb5b155246e.svg";
export { ForwardRef as ReactComponent };